
import { CANDIDATE_INTERVIEW_REQUEST, CANDIDATE_INTERVIEW_SUCCESS, CANDIDATE_INTERVIEW_FAIL } from "../constants/AuthConstant"

const initialState = {
  loading: false,
  action: "Job Action",
  result: [],
  msg: "",
  error: "",
};

const CandidateInterviewReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_INTERVIEW_REQUEST:
      return {
        ...state,
        loading: action.payload,
      };
    case CANDIDATE_INTERVIEW_SUCCESS:
      return {
        ...state,
        result: action.result.data,
        loading: action.payload,
        msg: action.msg,
      };
    case CANDIDATE_INTERVIEW_FAIL:
      return {
        ...state,
        error: action.error,
        loading: action.payload,
        msg: action.msg,
      };

    default:
      return state;
  }
};

export default CandidateInterviewReducer;
